<template>
  <div>
    <!-- ヘッダー -->
    <v-app-bar color="primary" dark v-if="clas">
      <v-btn style="position: absolute" icon @click="routerBack">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title style="min-width: fit-content;">{{ clas.className }} 日誌</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <!-- 日付選択 -->
    <div class="header-wrapper">
      <div @click="openDateDialog">
        <DatePager :date="date" @addDay="addDay" @subtractDay="subtractDay" />
      </div>

      <v-divider></v-divider>
    </div>

    <v-container>
      <div>
        <div class="text-h6 font-weight-bold">ねらい</div>
        <v-textarea
          class="pt-0"
          auto-grow
          rows="3"
          solo
          flat
          background-color="grey lighten-2"
          v-model="aim"
        ></v-textarea>
      </div>
      <div>
        <div class="text-h6 font-weight-bold">活動内容　午前</div>
        <v-textarea
          class="pt-0"
          auto-grow
          rows="3"
          solo
          flat
          background-color="grey lighten-2"
          v-model="activityAm"
        ></v-textarea>
      </div>
      <div>
        <div class="text-h6 font-weight-bold">活動内容　午後</div>
        <v-textarea
          class="pt-0"
          auto-grow
          rows="3"
          solo
          flat
          background-color="grey lighten-2"
          v-model="activityPm"
        ></v-textarea>
      </div>
      <div>
        <div class="text-h6 font-weight-bold">評価と反省</div>
        <v-textarea
          class="pt-0"
          auto-grow
          rows="3"
          solo
          flat
          background-color="grey lighten-2"
          v-model="assessment"
        ></v-textarea>
      </div>
      <div>
        <div class="text-h6 font-weight-bold">保護者支援</div>
        <v-textarea
          class="pt-0"
          auto-grow
          rows="3"
          solo
          flat
          background-color="grey lighten-2"
          v-model="support"
        ></v-textarea>
      </div>
      <div>
        <div class="text-h6 font-weight-bold">申請者</div>
        <v-select
          :items="allStaff"
          item-title="fullName"
          item-value="userId"
          v-model="appliedBy"
          variant="outlined"
        ></v-select>
      </div>

      <v-row class="flex-column mt-3 mb-5" align-content="center" justify="center">
        <v-col cols="6">
          <v-btn
            class=""
            color="#6C6C6C"
            dark
            depressed
            width="100%"
            @click="saveDraft"
            :loading="btnDraftLoading"
            :disabled="!checkStatus"
          >
            <div>
              <div class="text-h6 font-weight-bold message-btn">申請解除</div>
            </div>
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
            class=""
            color="primary"
            depressed
            width="100%"
            @click="saveApply"
            :loading="btnApplyLoading"
            :disabled="checkStatus"
          >
            <div v-if="checkStatus">
              <div class="text-h6 font-weight-bold message-btn">申請済</div>
            </div>
            <div v-else>
              <div class="text-h6 font-weight-bold message-btn">申請</div>
            </div>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackbar" :timeout="timeout" outlined top color="primary">
      {{ snackBarText }}

      <!-- <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
          ×
        </v-btn>
      </template> -->
      <template v-slot:actions>
        <v-btn
          color="outline-primary"
          variant="text"
          @click="snackbar = false"
        >
          ×
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog
      v-model="dateDialogFlg"
      width="auto"
    >
        <v-date-picker
            v-model="selectedDate"
            type="date"
            :day-format="(date) => new Date(date).getDate()"
            @update:model-value="dateSelected"
            no-title
            hide-header
            color="primary"
            style="transform: scale(0.8);"
        >
        </v-date-picker>
    </v-dialog>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";
import DatePager from '@/components/molecules/DatePager.vue';

import dayjs from 'dayjs';
import ja from 'dayjs/locale/ja';
import LocalDataService from '@/service/LocalDataService';
import { nurseryModule } from '@/store/dataModules/nurseryModule';
import { ClassDiaryResponse, NurseryClassResponse } from 'chaild-api/lib';
import { diaryReportModule } from '@/store/dataModules/diaryReportModule';
import { NurseryUserResponse } from 'chaild-api/src/component/nursery/user/types';
dayjs.locale(ja);

export default defineComponent({
  components: {
    DatePager,
  },
  data: () => {
    return {
      date: '' as any,
      classId: 0,
      aim: '',
      activityAm: '',
      activityPm: '',
      assessment: '',
      support: '',
      appliedBy: '',
      timeout: 2000,
      snackBarText: '',
      snackbar: false,
      btnApplyLoading: false,
      btnDraftLoading: false,
      classDiary: null as ClassDiaryResponse | null | any,
      dateDialogFlg: false,
      selectedDate: dayjs().format('YYYY-MM-DD'),
      addflg: false,
      subtractflg: false,
    };
  },
  computed: {
    clas(): NurseryClassResponse | null {
      if (nurseryModule.clas) {
        return nurseryModule.clas;
      }
      return null;
    },
    allStaff(): NurseryUserResponse[] {
      if (nurseryModule.allUser) {
        let allStaff = [] as any;
        nurseryModule.allUser.users.map(user => {
          allStaff.push({
            userId: user.userId,
            fullName: user.lastName + user.firstName,
          });
        });
        return allStaff;
      }
      return [];
    },
    checkStatus(): boolean {
      if (this.classDiary) {
        if (this.classDiary.error === 'E014') {
          return false;
        } else if (this.classDiary.status === 'applied') {
          return true;
        } else {
          false;
        }
      }
      return false;
    },
    // classDiary(): ClassDiaryResponse | null {
    //   if (diaryReportModule.classDiary) {
    //     return diaryReportModule.classDiary
    //   }
    //   return null;
    // }
  },
  watch: {
    date: {
      handler() {
        this.init();
      },
      deep: true,
    },
  },
  methods: {
    routerBack() {
      this.snackbar = false;
      const routes = window.history.length
      if(routes > 1) {
        this.$router.back()
      } else {
        this.$router.push(`/record/class/${this.classId}`);
      }
    },
    addDay() {
      this.date = this.date.add(1, 'd');
      this.addflg = true;
    },
    subtractDay() {
      this.date = this.date.subtract(1, 'd');
      this.subtractflg = true;
    },
    openDateDialog() {
      if (this.addflg || this.subtractflg) {
        this.addflg = false;
        this.subtractflg = false;
        return
      }
      this.selectedDate = this.date.format('YYYY-MM-DD');
      this.dateDialogFlg = true;
    },
    dateSelected(day) {
      this.date = dayjs(day);
      this.selectedDate = dayjs(day).format('YYYY-MM-DD');
      this.dateDialogFlg = false;
    },
    saveDraft: async function() {
      if (!this.classDiary || this.classDiary.error === 'E014') {
        try {
          this.btnDraftLoading = true;
          const response = await diaryReportModule.createClassDiary({
            classId: this.classId,
            date: this.date.format('YYYY-MM-DD'),
            aim: this.aim,
            activityAm: this.activityAm,
            activityPm: this.activityPm,
            assessment: this.assessment,
            support: this.support,
            status: 'draft',
            appliedBy: this.appliedBy,
          });
          this.btnDraftLoading = false;
          this.classDiary = response;
          this.snackBarText = '下書き保存しました';
          this.snackbar = true;
        } catch (e) {
          console.log(e);
        } finally {
          this.btnDraftLoading = false;
        }
      } else if (this.classDiary) {
        try {
          this.btnDraftLoading = true;
          const response = await diaryReportModule.updateClassDiary({
            classDiaryId: this.classDiary.classDiaryId.toString(),
            aim: this.aim,
            activityAm: this.activityAm,
            activityPm: this.activityPm,
            assessment: this.assessment,
            support: this.support,
            status: 'draft',
            appliedBy: this.appliedBy,
          });
          this.btnDraftLoading = false;
          this.classDiary = response;
          this.snackBarText = '下書き保存しました';
          this.snackbar = true;
        } catch (e) {
          console.log(e);
        } finally {
          this.btnDraftLoading = false;
        }
      }
    },
    saveApply: async function() {
      if (!this.classDiary || this.classDiary.error === 'E014') {
        try {
          this.btnApplyLoading = true;
          const response = await diaryReportModule.createClassDiary({
            classId: this.classId,
            date: this.date.format('YYYY-MM-DD'),
            aim: this.aim,
            activityAm: this.activityAm,
            activityPm: this.activityPm,
            assessment: this.assessment,
            support: this.support,
            status: 'applied',
            appliedBy: this.appliedBy,
          });
          this.btnApplyLoading = false;
          this.classDiary = response;
          this.snackBarText = '申請しました';
          this.snackbar = true;
        } catch {}
      } else if (this.classDiary) {
        try {
          this.btnApplyLoading = true;
          const response = await diaryReportModule.updateClassDiary({
            classDiaryId: this.classDiary.classDiaryId.toString(),
            aim: this.aim,
            activityAm: this.activityAm,
            activityPm: this.activityPm,
            assessment: this.assessment,
            support: this.support,
            status: 'applied',
            appliedBy: this.appliedBy,
          });
          this.btnApplyLoading = false;
          this.classDiary = response;
          this.snackBarText = '申請しました';
          this.snackbar = true;
        } catch {}
      }
    },
    init: async function() {
      this.aim = '';
      this.activityAm = '';
      this.activityPm = '';
      this.assessment = '';
      this.support = '';
      const user = LocalDataService.getUser();
      const classId = this.$route.params.classId;
      this.classId = parseInt(classId as string, 10);
      if (user) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        const nurseryId = nurserySchool.nurseryId;
        await diaryReportModule.fetchClassDiary({
          classId: classId as string,
          date: this.date.format('YYYY-MM-DD'),
        });
        Promise.all([
          nurseryModule.getNurseryClassDetail({
            nurseryId,
            classId: this.classId,
          }),
          nurseryModule.getNurseryUser({ nurseryId: nurseryId, date: this.date.format('YYYY-MM-DD') }),
        ]);
        this.classDiary = await diaryReportModule.classDiary;
        if (this.classDiary) {
          if (
            this.classDiary.aim ||
            this.classDiary.activityAm ||
            this.classDiary.activityPm ||
            this.classDiary.assessment ||
            this.classDiary.support ||
            this.classDiary.createdBy
          ) {
            this.aim = this.classDiary.aim!;
            this.activityAm = this.classDiary.activityAm!;
            this.activityPm = this.classDiary.activityPm!;
            this.assessment = this.classDiary.assessment!;
            this.support = this.classDiary.support!;
            if (this.classDiary.status !== 'draft') {
              this.appliedBy = this.classDiary.createdBy.userNurseryId!;
            }
          }
        }
      }
    },
  },
  async created() {
    const date = this.$route.query.date as string;
    if (date) {
      const temp = dayjs(date);
      this.date = temp;
    } else {
      this.date = dayjs();
    }
  },
  async mounted() {
    this.init();
  },
  beforeDestroy() {
  },
});
</script>
<style lang="scss" scoped>
@use '@/sass/variables.scss' as *;

.diary-text {
  background: #f5f6f6;
}
</style>
